import section from '../components/Section/sectionVariants';

const theme = {
  section,
};

export default theme;
